import { toast } from "react-toastify";
import alertDanger from '../assets/images/icons/alert-danger.svg';
import alertSuccess from '../assets/images/icons/alert-success.svg';
// import alertOrange from '../assets/images/icons/alert-ornage.svg';
export const notifysuccess = (msg) => toast.success(
  <>
    <img src={alertSuccess} alt="" className="me_12" />
    <span className="text">{msg}</span>
  </>,
  {
    autoClose: 1500, position: "top-center"
  });
// export const notifysuccess = (msg) => toast.success(msg, { autoClose: 1500 });
export const notifyfailure = (msg) => toast.error(
  <>
    <img src={alertDanger} alt="" className="me_12" />
    <span className="text">{msg}</span>
  </>,
  {
    autoClose: 2000, position: "top-center"
  });

export const notifycatch = () => toast.error(
  <>
    <img src={alertDanger} alt="" className="me_12" />
    <span className="text">Something went wrong</span>
  </>,
  {
    autoClose: 1500, position: "top-center"
  });

  export const notifywarning = (msg) => toast.error(
    <>
      <img src={alertSuccess} alt="" className="me_12" />
      <span className="text">{msg}</span>
    </>,
    {
      autoClose: 1500, position: "top-center"
    });
    
// export const notifycatch = () => toast.error("Something went wrong", { autoClose: 1500 });